import { BasicLayout, AccountLayout, BlankLayout } from '@/components/layouts';
import Exception from '@/views/Exception.vue';
import ExceptionImage403 from '@/assets/exception_403.png';
import ExceptionImage404 from '@/assets/exception_404.png';
import ExceptionImage500 from '@/assets/exception_500.png';

import data from '@/router/modules/data';
import MyApp from '@/router/modules/my-app';
import LinklongApp from '@/router/modules/linklong-app';
import MyConfig from '@/router/modules/my-config';
import MySystem from '@/router/modules/my-system';
import plugin, { mobileFullScreen } from '@/router/modules/plugin';

export default [
  window.__POWERED_BY_QIANKUN__ ? LinklongApp : MyApp,
  MyConfig,
  data,
  MySystem,
  plugin,
  mobileFullScreen,
  {
    path: '/exception',
    name: 'Exception',
    component: BasicLayout,
    redirectToChild: true,
    hiddenInMenu: true,
    meta: {
      title: '异常',
      icon: 'warning',
    },
    children: [
      {
        path: '/exception/403',
        name: 'Exception.403',
        component: Exception,
        meta: {
          title: '403',
        },
        props: {
          sourceData: {
            imageUrl: ExceptionImage500,
            type: 403,
            title: '抱歉，你无权访问该页面',
            showHomeButton: true,
          },
        },
      },
      {
        path: '/exception/404',
        name: 'Exception.404',
        component: Exception,
        meta: {
          title: '404',
        },
        props: {
          sourceData: {
            imageUrl: ExceptionImage404,
            type: 404,
            title: '抱歉，你访问的页面找不到了',
            showHomeButton: true,
          },
        },
      },
      {
        path: '/exception/500',
        name: 'Exception.500',
        component: Exception,
        meta: {
          title: '500',
        },
        props: {
          sourceData: {
            imageUrl: ExceptionImage403,
            type: 500,
            title: '抱歉，服务器出错了',
            showHomeButton: true,
          },
        },
      },
    ],
  },
  {
    path: '/account',
    name: 'Account',
    component: AccountLayout,
    redirectToChild: true,
    hiddenInMenu: true,
    meta: {},
    children: [
      {
        path: '/account/setting',
        name: 'Account.Setting',
        component: BlankLayout,
        redirectToChild: true,
        meta: {
          title: '设置',
          icon: 'user',
        },
        children: [
          {
            path: '/account/setting/basic',
            name: 'Account.Setting.Basic',
            component: () => import(/* webpackChunkName: "account" */ '@/views/account/setting/Basic.vue'),
            meta: {
              title: '基本设置',
            },
          },
          {
            path: '/account/setting/security',
            name: 'Account.Setting.Security',
            component: () => import(/* webpackChunkName: "account" */ '@/views/account/setting/Security.vue'),
            meta: {
              title: '安全设置',
            },
          },
        ],
      },
      {
        path: '/account/binding',
        name: 'Account.Binding',
        component: () => import(/* webpackChunkName: "account" */ '@/views/account/Binding.vue'),
        meta: {
          title: '账号绑定',
          icon: 'deployment-unit',
        },
      },
    ],
  },
];
